// extracted by mini-css-extract-plugin
export default {"tableDataContainer":"TableData__tableDataContainer--3ih","accordionContainer":"TableData__accordionContainer--Fu7"};